import { ClientAreaDomain } from '@/api/ClientArea/ClientAreaDomain'
import { AudienceTypeDto } from '@/routes/Marketing/Notifications/NotificationDetailsForm'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PromoMaterialsOptionsDto } from 'api/ClientArea/PromoMaterialsOptionsDto'
import { NameDto } from 'api/Common/Types'

import { ClientAreaState } from './types'

const initialState: ClientAreaState = {
  notificationAudienceTypes: [],
  notificationTypes: [],
  notificationPlatforms: [],
  notificationProductStatuses: [],
  baseUrlTypes: [],
  promoMaterialsOptions: {
    sizes: [],
    categories: [],
    types: [],
    baseUrls: [],
  },
  domain: undefined,
  emailGroupTypes: [],
  emailFromTypes: [],
  referralMaterialsTypes: [],
  referralMaterialsPromoSizes: [],
  referralMaterialsPromoContentTypes: [],
  referralMaterialsCategoriesByEntity: [],
  userDashboardsLayouts: [],
}

export const clientAreaSlice = createSlice({
  name: 'clientArea',
  initialState,
  reducers: {
    setNotificationAudienceTypes: (
      state: ClientAreaState,
      action: PayloadAction<AudienceTypeDto[]>
    ) => {
      state.notificationAudienceTypes = action.payload
    },
    setNotificationTypes: (state: ClientAreaState, action: PayloadAction<NameDto[]>) => {
      state.notificationTypes = action.payload
    },
    setNotificationPlatforms: (state: ClientAreaState, action: PayloadAction<NameDto[]>) => {
      state.notificationPlatforms = action.payload
    },
    setNotificationProductStatuses: (state: ClientAreaState, action: PayloadAction<NameDto[]>) => {
      state.notificationProductStatuses = action.payload
    },
    setBaseUrlTypes: (state: ClientAreaState, action: PayloadAction<NameDto[]>) => {
      state.baseUrlTypes = action.payload
    },
    setPromoMaterialsOptions: (
      state: ClientAreaState,
      action: PayloadAction<PromoMaterialsOptionsDto>
    ) => {
      state.promoMaterialsOptions = action.payload
    },
    setDomain: (state: ClientAreaState, action: PayloadAction<ClientAreaDomain>) => {
      state.domain = action.payload
    },
    setEmailGroupTypes: (state: ClientAreaState, action: PayloadAction<NameDto<string>[]>) => {
      state.emailGroupTypes = action.payload ?? []
    },
    setEmailFromTypes: (state: ClientAreaState, action: PayloadAction<NameDto<string>[]>) => {
      state.emailFromTypes = action.payload ?? []
    },
    setReferralMaterialsTypes: (state: ClientAreaState, action: PayloadAction<NameDto[]>) => {
      state.referralMaterialsTypes = action.payload ?? []
    },
    setReferralMaterialsPromoSizes: (state: ClientAreaState, action: PayloadAction<NameDto[]>) => {
      state.referralMaterialsPromoSizes = action.payload ?? []
    },
    setReferralMaterialsPromoContentTypes: (
      state: ClientAreaState,
      action: PayloadAction<NameDto[]>
    ) => {
      state.referralMaterialsPromoContentTypes = action.payload ?? []
    },
    setReferralMaterialsCategoriesByEntity: (
      state: ClientAreaState,
      action: PayloadAction<(NameDto<string> & { isActive: boolean })[]>
    ) => {
      state.referralMaterialsCategoriesByEntity = action.payload ?? []
    },
  },
})
